module.exports = __webpack_public_path__ + "static/media/20201219_113047_216_IMG_3357.4491bddf.jpg";